import api from '../service/service.js'
import Swal from 'sweetalert2'
export default {
  name: 'member',
  data () {
    return {
      ac_id: 0,
      prefix_id: 0,
      l_name: '',
      f_name: '',
      username: '',
      password: '',
      new_password: '',
      conpassword: '',
      gender_id: 1,
      position: '',
      role_id: 0,
      active_status: 1,
      prefix: [],
      gender: [],
      role: []
    }
  },
  methods: {
    addUser () {
      if (
        this.username === '' ||
        this.password === '' ||
        this.l_name === '' ||
        this.f_name === '' ||
        this.position === ''
      ) {
        Swal.fire('ข้อความจากระบบ', 'กรุณากรอกข้อมูลให้ครบถ้วน !', 'warning')
        return 1
      }
      if (this.new_password !== this.conpassword) {
        Swal.fire(
          'ข้อความจากระบบ',
          'กรุณากรอกรหัสผ่านใหม่ให้ถูกต้อง !',
          'warning'
        )
        return 1
      }

      if (this.new_password.length < 6) {
        Swal.fire(
          'ข้อความจากระบบ',
          'รหัสผ่านต้องไม่น้อยกว่า 6 ตัวอักษร',
          'warning'
        )
        return 1
      }

      if (this.new_password !== '') {
        this.password = this.new_password
      }
      let payload = {
        username: this.username,
        password: this.password,
        prefix_id: this.prefix_id.toString(),
        fname: this.f_name,
        lname: this.l_name,
        gender_id: this.gender_id.toString(),
        position: this.position,
        role_id: this.role_id.toString(),
        active_status: this.active_status.toString()
      }
      console.log(payload)
      api.putuser(
        payload,
        result => {
          console.log(result)
          if (result.result === true) {
            this.alert_msg('success', 'ข้อความจากระบบ', 'บันทึกข้อมูลเรียบร้อย')
            this.$router.push({ name: 'users' })
            this.clear()
          } else {
            Swal.fire('ข้อความจากระบบ', result.data, 'warning')
          }
        },
        calback => {
          Swal.fire('ข้อความจากระบบ', calback, 'error')
          console.log(calback)
        }
      )
    },
    clear () {
      this.prefix_id = 0
      this.l_name = ''
      this.f_name = ''
      this.username = ''
      this.password = ''
      this.conpassword = ''
      this.role_id = 0
      this.gender_id = 0
      this.position = ''
    },
    getgender () {
      api.gender(
        result => {
          console.log(result)
          if (result.result === true) {
            this.gender = result.data
          }
        },
        calback => {
          console.log(calback)
        }
      )
    },
    getuser () {
      let payload = this.ac_id
      api.getusers(payload, result => {
        if (result.result === true) {
          console.log(result.data[0].ac_id)
          this.prefix_id = result.data[0].prefix_id
          this.l_name = result.data[0].lname
          this.f_name = result.data[0].fname
          this.username = result.data[0].username
          this.password = result.data[0].password
          this.role_id = result.data[0].role_id
          this.gender_id = result.data[0].gender_id
          this.position = result.data[0].position
          this.active_status = result.data[0].active_status
        }
      })
    },
    getprefix () {
      api.prefix(
        result => {
          console.log(result)
          if (result.result === true) {
            this.prefix = result.data
            console.log(this.prefix)
          }
        },
        calback => {
          console.log(calback)
        }
      )
    },
    getRole () {
      api.role(
        result => {
          console.log(result)
          if (result.result === true) {
            this.role = result.data
          }
        },
        calback => {
          console.log(calback)
        }
      )
    }
  },
  mounted () {
    this.ac_id = this.$route.params.id
    this.getuser()
    this.getgender()
    this.getprefix()
    this.getRole()
    //  console.log(this.menu)
  }
}



// WEBPACK FOOTER //
// ./src/js/updateuser.js